import { emit } from 'chimera/all/plugins/eventbus/events/emit'
import { bindOn } from 'chimera/all/plugins/eventbus/events/bind'
import { getEventScope } from 'chimera/all/plugins/eventbus/scope'

export const leadStoreUpdateEvent = 'eb_leadStoreUpdate'

/**
 * @param {object} obj
 * @param {string} key
 * @returns {boolean}
 */
function hasKey(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key)
}

/**
 * @param {object} obj
 * @returns {boolean}
 */
function isNotEmpty(obj) {
  return Object.keys(obj).length > 0
}

/**
 * @param {object} prev
 * @param {object} next
 * @returns {object}
 */
function findAddedKeys(prev, next) {
  const added = {}

  for (const key of Object.keys(next)) {
    if (!hasKey(prev, key)) {
      added[key] = next[key]?.value
    }
  }

  return added
}

/**
 * @param {object} prev
 * @param {object} next
 * @returns {object}
 */
function findRemovedKeys(prev, next) {
  const removed = {}

  for (const key of Object.keys(prev)) {
    if (!hasKey(next, key)) {
      removed[key] = prev[key]?.value
    }
  }

  return removed
}

/**
 * @param {object} prev
 * @param {object} next
 * @returns {object}
 */
function findChangedKeys(prev, next) {
  const changed = {}

  for (const key of Object.keys(next)) {
    const existsInBoth = hasKey(prev, key)
    const hasChanged = JSON.stringify(prev[key]) !== JSON.stringify(next[key])

    if (existsInBoth && hasChanged) {
      changed[key] = `${prev[key]?.value} → ${next[key]?.value}`
    }
  }

  return changed
}

/**
 * @param {object} prev
 * @param {object} next
 * @returns {object}
 */
function getChangeSet(prev, next) {
  const added = findAddedKeys(prev, next)
  const removed = findRemovedKeys(prev, next)
  const changed = findChangedKeys(prev, next)

  const diff = {}

  if (isNotEmpty(added)) {
    diff.added = added
  }
  if (isNotEmpty(removed)) {
    diff.removed = removed
  }
  if (isNotEmpty(changed)) {
    diff.changed = changed
  }

  return isNotEmpty(diff) ? diff : null
}

/**
 * @returns {function(object): void}
 */
function createLeadStoreUpdateEmitter() {
  let previousData = null

  return function (data) {
    const currentData = data || {}
    const changeSet = getChangeSet(previousData || {}, currentData)
    previousData = { ...currentData }

    if (!changeSet) {
      return
    }

    emit(
      leadStoreUpdateEvent,
      {
        data,
        scope: process.client ? getEventScope() : {},
      },
      { logData: changeSet },
    )
  }
}

export const emitLeadStoreUpdateEvent = createLeadStoreUpdateEmitter()

/**
 * @param {Function} callback
 */
export function onLeadStoreUpdateEvent(callback) {
  bindOn(leadStoreUpdateEvent, callback)
}
